import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';

import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from 'react-router-dom';

const ProjectProp = forwardRef((props, ref) => {

    //#region const 

    let navigate = useNavigate();
    const [Id, setId] = useState(General.GuidEmpty());
    const [Title, setTitle] = useState("");
    const [ShowLoader, setShowLoader] = useState(false);

    //#endregion

    //#region Methods 

    useImperativeHandle(ref, () => ({
        ShowEdit(Id) {
            if (Id != undefined)
                setId(Id);
        }
    }))



    const handleSubmit = (e) => {
        e.preventDefault();
        if (Title === "") {
            General.ShowMsg(Enum.MsgType.error, "عنوان پروژه را مشخص نمایید");
            return;
        }

        setShowLoader(true);
        var RequestOption = {
            method: 'Post',
            url: General.ApiRoute() + '/Project/Save',
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
            data: {
                "Id": Id,
                "Title": Title
            },
            withCredentials: true
        }
        trackPromise(
            axios(RequestOption)
                .then(function (res) {
                    if (res.data.isSuccess) {

                        General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                        setShowLoader(false);
                        props.onSubmit();
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, res.data.error);
                        setShowLoader(false);
                    }

                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                        }
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                        setShowLoader(false);
                    }
                })
        )
    };

    const Bind = () => {
        setShowLoader(true);
        var RequestOption = {
            mthod: 'Get',
            url: General.ApiRoute() + "/Project/GetById",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            }
            , withCredentials: true


        }

        axios(RequestOption)
            .then(function (res) {
                setTitle(res.data.title);

                setShowLoader(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                    }
                    else if (error.response.status === 403) {
                        General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }

    useEffect(() => {
        if (Id != General.GuidEmpty())
            Bind();
    }, [Id])
    //#endregion


    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>عنوان</label>
                <rsuite.Input
                    type="text"
                    value={Title}
                    onChange={value => setTitle(value)}
                    required />
            </div>

            <rsuite.Divider />
            <div align="left">
                {
                    !ShowLoader ?

                        <rsuite.Button appearance="primary" className="mt-2" onClick={handleSubmit}>
                            ثبت پروژه
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mt-2" disabled>
                            <rsuite.Loader content="در حال ارسال اطلاعات..." />
                        </rsuite.Button>
                }
            </div>

        </form>
    );
});

export default ProjectProp;